import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { BlogListComponent } from './blog/blogList.component';
import { BlogComponent } from './blog/blog.component';
import { NewBlogComponent } from './blog/newBlog.component';
import { LoginComponent } from './login/login.component';

import { DataService } from '../shared/dataService';

let routes = [
    { path: "", component: BlogComponent },
    { path: "addBlog", component: NewBlogComponent },
    { path: "Blog", component: BlogListComponent },
    { path: "login", component: LoginComponent}
];

@NgModule({
    declarations: [
        AppComponent,
        BlogListComponent,
        BlogComponent,
        NewBlogComponent,
        LoginComponent
    ],
    imports: [
        FormsModule,
        BrowserModule,
        HttpClientModule,
        RouterModule.forRoot(routes, {
            useHash: true, // we are not building a whole app but enhancing a single page so we want the routes to show after a #
            enableTracing: false // for Debugging of the routes
        })
    ],
    providers: [
        DataService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
